import {useMutation} from "@tanstack/react-query";
import {createGroup} from "../services/GroupService";

export function useGroupCreate() {
    return useMutation({
        mutationFn: createGroup,
    });
}
